import styled from "styled-components";

export const TrainContainer = styled.div`
  margin-top: 48px;
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  max-width: 1440px;
  padding: 0px 16px;
  padding-bottom: 81px;
`;

export const TrainGrid = styled.div`
  display: grid;
  gap: 20px;
  width: 100%;

  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));

  @media (min-width: 1400px) {
    grid-template-columns: repeat(4, 1fr);
  }

  @media (min-width: 1024px) and (max-width: 1399px) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media (min-width: 600px) and (max-width: 1023px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;
  }

  @media (max-width: 599px) {
    grid-template-columns: 1fr;
    gap: 12px;
  }

  contain: layout style;
`;

export const TrainModelCard = styled.div`
  border-radius: 24px;
  border: 1px solid var(--100, #4d9dff);
  background: linear-gradient(
    180deg,
    var(--300, #0f4e9e) 0%,
    var(--400, #072e61) 100%
  );

  display: flex;
  width: 100%;
  height: 403px;
  padding: 24px;
  cursor: pointer;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 24px;

  transition: transform 0.3s ease, box-shadow 0.3s ease;

  will-change: transform;
  backface-visibility: hidden;
  contain: layout style paint;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 12px 32px rgba(40, 119, 217, 0.3);
  }

  &:active {
    transform: translateY(-2px);
  }

  @media (max-width: 1023px) {
    padding: 20px;
    gap: 20px;
  }

  @media (max-width: 599px) {
    height: auto;
    min-height: 320px;
    padding: 16px;
    gap: 16px;
    border-radius: 16px;
  }
`;

export const TrainGridContainer = styled.div`
  width: 100%;
  max-width: 1440px;
  margin: 0 auto;
  padding: 0 20px;

  @media (max-width: 599px) {
    padding: 0 16px;
  }
`;
export const Button = styled.button`
  display: flex;
  width: ${(props) => (props.$width ? "100%" : "180px")};
  height: 40px;
  padding: 12px 44px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 100px;
  background: #fff;
  border: none;
  outline: none;

  color: #09090b;
  font-family: DM Sans;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: -0.21px;
  cursor: pointer;

  &:disabled {
    cursor: not-allowed;
  }
`;

export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  /* justify-content: center; */
  padding: 28px 20px 60px 20px;
  text-align: center;
  flex: 1;

  h3 {
    font-size: 24px;
    margin-bottom: 12px;
    font-family: DM Sans;
  }

  p {
    font-size: 16px;
    line-height: 1.5;
    max-width: 400px;
    font-family: DM Sans;

    opacity: 0.6;
    margin-bottom: 24px;
  }
`;

export const CardIcon = styled.div`
  width: 64px;
  height: 64px;
  background: linear-gradient(135deg, #43e97b, #38f9d7);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #1a1a2e;
  font-size: 24px;
  margin-bottom: 8px;
`;

export const CardTitle = styled.h3`
  color: #fff;
  text-align: center;
  font-family: DM Sans;
  font-size: 24px;
  font-weight: 500;
  letter-spacing: -0.12px;
`;

export const CardDescription = styled.p`
  font-size: 14px;
  line-height: 1.5;
  margin: 0;
  color: ${({ theme }) =>
    theme === "light" ? "rgba(0, 0, 0, 0.6)" : "rgba(255, 255, 255, 0.7)"};
`;

export const ModelCard = styled.div`
  display: flex;
  width: 100%;
  height: 403px;
  padding: 12px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
  position: relative;

  border-radius: 24px;
  border: 0.5px solid #3d3d45;
  background: #18181b;
  cursor: pointer;

  transition: all 0.3s ease;
  &:hover {
    transform: translateY(-4px);
  }

  h3 {
    animation: preparing-pulse-text 2s ease-in-out infinite;
  }

  @keyframes preparing-pulse-text {
    0%,
    100% {
      transform: scale(1);
      opacity: 1;
    }
    50% {
      transform: scale(0.985);
      opacity: 0.8;
    }
  }

  transition: transform 0.3s ease, box-shadow 0.3s ease;

  will-change: transform;
  backface-visibility: hidden;
  contain: layout style paint;

  &:active {
    transform: translateY(-2px);
  }

  @media (max-width: 1023px) {
    padding: 20px;
    gap: 20px;
  }

  @media (max-width: 599px) {
    height: auto;
    min-height: 320px;
    padding: 16px;
    gap: 16px;
    border-radius: 16px;
  }
`;

export const ModelIcon = styled.div`
  width: 48px;
  height: 48px;
  background: ${({ theme }) =>
    theme === "light" ? "rgba(0, 0, 0, 0.1)" : "rgba(255, 255, 255, 0.1)"};
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #2877d9;
  font-size: 18px;
  margin-bottom: 8px;
`;

export const ModelTitle = styled.h4`
  position: absolute;
  left: 16px;
  bottom: 16px;

  color: #fff;
  font-family: DM Sans;
  font-size: 18px;
  font-weight: 400;
  letter-spacing: -0.09px;
`;

export const ModelStatus = styled.div`
  margin-top: 8px;
`;

export const ModelStatusText = styled.span`
  background: ${({ theme }) =>
    theme === "light" ? "rgba(255, 193, 7, 0.2)" : "rgba(255, 193, 7, 0.3)"};
  color: ${({ theme }) => (theme === "light" ? "#b8860b" : "#ffc107")};
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;
